module.exports = __webpack_public_path__ + "img/w3_olja_light.af6bcd85.png";